"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GOOGLE_PLACES_ESTABLISHMENT_TYPES = exports.GOOGLE_PLACES_SEARCH_TYPES = void 0;
exports.GOOGLE_PLACES_SEARCH_TYPES = [
    "bar",
    "night_club",
    "point_of_interest",
    "route",
    "premise",
];
exports.GOOGLE_PLACES_ESTABLISHMENT_TYPES = [
    "bar",
    "establishment",
    "night_club",
    "point_of_interest",
];
//# sourceMappingURL=location.js.map